export default {
  pending: 'Pending',
  accepted: 'Accepted',
  serviceStarted: 'Service started',
  finished: 'Finished',
  tariffBased: 'Tariff based',
  cancelReason: 'Cancel reason',
  cancelDescription: 'Cancel description',
  generalLoadInformation: 'General load information',
  package: 'package',
  typeOfShippingDocument: 'Type of shipping document',
  monetaryValue: 'Monetary value',
  furnitureDate: 'Furniture date',
  furnitureHour: 'Furniture hour',
  loadDate: 'Load date',
  loadHour: 'Load hour',
  dischargeDate: 'Discharge date',
  dischargeTime: 'Discharge time',
  areYouSureToAccept_courierForThisLoad:
    "Are you sure to accept ' {courier} ' for this load?",
  areYouSureToCancel_courierForThisLoad:
    "Are you sure to cancel ' {courier} ' for this load?",
  areYouSureToAcceptable_courierForThisLoad:
    "Are you sure to acceptable ' {courier} ' for this load?",

  areYouSureToAcceptForThisLoad: 'Are you sure to accept driver for this load?',
  insuranceCost: 'Insurance cost',
  isTotalAmountOf_rialsApproved:
    'Is Total amount of {totalAmount} Rials approved?',
  doYouWantAccept_companyForThisLoad:
    "Do you want to accept ' {company} ' company for this load?",
  totalExcessAmountOf_rialsApproved:
    'Total excess amount of {excessAmount} Rials ({total}) approved?',
  totalCostOf_rialsApproved: 'Total cost of {totalCost} Rials approved?',
  areYouSureOfStartingThisLoadWithoutAssigningDriver:
    'Are you sure of starting this load without assigning driver?',
  areYouSureYouWantToFinishThisLoad:
    'Are you sure you want to finish this load?',
  areYouSureYouWantToRevert_nameAcceptance:
    'Are you sure you want to revert {name} acceptance?',
  areYouSureYouWantToRevertAssignedDriversOfThisLoad:
    'Are you sure you want to revert assigned drivers of this load?',
  revertLoadSteps: 'Revert load steps',
  startWithoutAssignDriver: 'Start without assign driver',
  revertStartWithoutAssignDriver: 'Revert start without assign driver',
  areYouSureYouWantToRevertLoadSteps:
    'Are you sure you want to revert load steps?',
  areYouSureYouWantToRevertStartWithoutAssignDriver:
    'Are you sure you want to revert start without assign driver?',
  areYouSureYouWantToRevertFinish: 'Are you sure you want to revert finish?',
  areYouSureYouWantToAssignThisDriverForThisOrder:
    'Are you sure you want to assign this driver for this order',
  assignDriver: 'Assign driver',
  reassignDriver: 'Reassign driver',
  areYouSureYouWantToDeleteThisDraft:
    'Are you sure you want to delete this draft?',
  draftDeletedSuccessfully: 'Draft deleted successfully',
  pricing: 'Pricing',
  editPricing: 'Edit pricing',
  acceptOfCourier_: "Accept of courier ' {courier} '",
  areYouSureYouWantToAddOffersOf_companies:
    "Are you sure you want to add offer off ' {companies} ' courier/couriers?",
  areYouSureYouWantToAddOffer: 'Are you sure you want to add offer?',
  addingOffers: 'Adding offers',
  assignDriver: 'Assigning driver',
  activeTariff: 'Active tariff',
  assignDrivers: 'Assign driver(s)',
  reassignDrivers: 'Reassign driver(s)',
  markDriverCoordinatesOnMap: 'Mark driver coordinates on map',
  startMoving: 'Start moving',
  reachingTheOrigin: 'Reaching the origin',
  endOfDownload: 'End of download',
  reachingTheDestination: 'Reaching the destination',
  emptyingTheConsignment: 'Emptying the consignment',
  backTo_: 'Back to {step}',
  destinationToRevert: 'Destination to revert',
  updatingPrice: 'Updating price',
  loadHasBeenFinishedSuccessfully: 'Load has been finished successfully',
  cancelLoad: 'Cancel load',
  loadAsDraft: 'load as draft',
  ongoing: 'Ongoing',
  areYouSureYouWantToChangeThisLoadStateToOngoing:
    "Are you sure you want to change this load state to 'Ongoing'?",
  loadStateSuccessfullyChangedToOngoing:
    "Load state successfully changed to 'Ongoing'",
  shipmentDrafts: 'Order drafts',
  postalPostageDetail: 'Postal postage detail',
  defaultVehicle: 'Default vehicle',
  collectionTime: 'Collection time',
  stopInPlace: 'Stop in place',
  returnToOrigin: 'Return to origin',
  trackingCodeOf_: 'Tracking code of {title}',
  orderTracking: 'Order tracking',
  originAndDestinationInfo: 'Origin and destination info',
  estimatedTimeFromOriginToDestination:
    'Estimated time from origin to destination',
  distanceFromOriginToDestination: 'Distance from origin to destination',
  deliverer: 'Deliverer',
  transferee: 'Transferee',
  plate: 'Plate',
  floor: 'Floor',
  unit: 'Unit',
  distanceFromDoorToCar: 'Distance from door to car',
  destination1: 'First destination',
  destination2: 'Second destination',
  destination3: 'Third destination',
  destination4: 'Forth destination',
  destination5: 'Fifth destination',
  destination6: 'sixth destination',
  destination7: 'Seventh destination',
  destination8: 'Eight destination',
  destination9: 'Ninth destination',
  destination10: 'Tenth destination',
  finalDestination: 'Final destination',
  originWeightOfWeighbridge: 'Origin weight of weighbridge',
  destinationWeightOfWeighbridge: 'Destination weight of weighbridge',
  receiptOfWeighbridge: 'Receipt of weighbridge',
  laborerCount: 'Laborer count',
  carLoad: 'Load',
  driverMobile: 'Driver mobile',
  courierShare: 'Courier share',
  driverShare: 'Driver share',
  carPriceDetails: 'Car price details',
  laborerPriceDetails: 'Laborer price details',
  technicalForce: 'Technical force',
  costlyItems: 'Costly items',
  otherItems: 'Other items',
  diverSuggestedAmount: 'Driver suggested amount',
  driverName: 'Driver name',
  dtiverNationalId: 'Driver national ID',
  vehicleSmartCardNumber: 'Vehicle smart number',
  courierOffer: 'Couriers offer',
  priced: 'Priced',
  waitingForPricing: 'Waiting fro pricing',
  excessCost: 'Excess cost',
  submitExcessCost: 'Submit excess cost',
  editExcessCost: 'Edit excess cost',
  acceptCourier: 'Accept courier',
  submitExcessCostFor_: "Submit excess cost for '{courier}'",
  editExcessCostOf_: "Edit excess cost of '{courier}'",
  courierCostDetail_: '{courier} cost detail',
  totalExcessCost: 'Total excess cost',
  pricing: 'Pricing',
  pricingCourierOffer_: 'Pricing {courier} offer',
  editPrice: 'Edit price',
  editPriceOfCourierOffer_: 'Edit price of {courier} offer',
  amountUnderCommissionError:
    'Entred amount is under commition amount ({commissionAmount})',
  totalAmountUnderCommissionError:
    'Total entred amount is under commition amount ({commissionAmount})',
  addOffer: 'Add offer',
  noNewOffers: 'No new offers',
  noNewPackages: 'No new packages',
  distance: 'Distance',
  carPayableAmount: 'Car payable amount',
  laborerPayableAmount: 'Laborer payable amount',
  carCostDetail: 'Car cost detail',
  technicalForceCostDetail: 'Technical force cost detail',
  costlyItemsCostDetail: 'Costly items cost detail',
  otherItemsCostDetail: 'Other items cost detail',
  postalPostageSpecifications: 'Postal postage specifications',
  monetaryValue: 'Monetary value',
  customerMobile: 'Customer mobile',
  cancelOrder: 'Cancel order',
  continueOrderRegistration: 'Continue order registration',
  areYouSureYouWantToDeleteThisTemplate:
    'Are you sure you want to delete this template?',
  templateDeletedSuccessfully: 'Template deleted successfully',
  loadDetail: 'Load detail',
  notStarted: 'Not started',
  loadSteps: 'Load steps',
  stepsToAdvanceTheLoad: 'Steps to advance the load',
  pleaseSelectVehicle: 'Please select vehicle',
  resetCoordinates: 'Reset coordinates',
  startOrderForBranch: 'Start order for branch',
  stepsHistory: 'Steps history',
  noStepDoneYet: 'No step done yet',
  noResponseHasBeenRecordedForThisFeedbackYet:
    'No response has been recorded for this feedback yet',
  recordResponse: 'Record response',
  noFeedbackHasBeenRecordedForThisShipmentYet:
    'No feedback has been recorded for this order yet',
  recordFeedback: 'Record feedback',
  dischargeDayPart: 'Discharge day part',
  orderTime: 'Order time',
  orderDate: 'Order date',
  waitMinute: 'Wait miniute',
  roundTrip: 'Round trip',
  updateShipmentMainInfo: 'Update order main info',
  loadType: 'Load type',
  packageType: 'Package type',
  weight: 'weight',
  loadWeight: 'Load weight',
  kilogram: 'Kilogram',
  templateId: 'Template ID',
  draftId: 'Draft ID',
  otherCost: 'Other cost',
  totalCost: 'Total cost',
  tax: 'Tax',
  toll: 'Toll',
  badpaShare: 'Badpa share',
  MainCourierShare: 'Main courier share',
  pricingType: 'Pricing type',
  loadRange: 'Load range',
  registerOrderTime: 'Register order time',
  deliveryCode: 'Delivery code',
  deliveryResult: 'Delivery result',
  deliverySuccessful: 'Successful delivery',
  deliveryFailed: 'Failed delivery',
  pleaseSelectDeliveryResult: 'Please select delivery result',
  dischargeShipmentCode: 'Discharge order code',
  sendDeliveryCodeToCustomer: 'send delivery code to customer',
  deliveryCodeSentSuccessfully: 'Delivery code sent successfully',
  cancelType: 'Cancel type',
  cancelLoadReason: 'Cancel load reason',
  cancelLoadDescription: 'Cancel load description',
  updatePrice: 'Update price',
  auctionCommissionWarning:
    'The amount you entered is less than commission amount ({commissionAmount} IRR)',
  recordOriginWeighbridge: 'Record origin weighbridge',
  recordDestinationWeighbridge: 'Record destination weighbridge',
  finishLoad: 'Finish',
  loadForwardSteps: 'Load forward steps',
  loadRevertSteps: 'Load revert steps',
  revertAcceptance: 'Revert acceptance',
  revertDriverAssignment: 'Revert driver assignment',
  coordinates: 'Coordinates',
  destination: 'Destination',
  cancelReason: 'Cancel reason',
  originAndDestinationShouldDiffrent: 'Orogin and destination should diffrent',
  addPackage: 'add package',
  atLeastOnePackageIsRequired: 'at least one package is required',
  reserveOrderForLater: 'Reserve order for the future',
  revertOffer: 'revert offer',
  atLeastOneEmployeeNeeded:
    'It is necessary to select at least one technical force to continue',
  driversOffers: 'Drivers offers',
  IWantInsurance: 'I want insurance',
  forAddCarToThisBarYouShouldRemoveAllCarExcludedCarsAreYouSure:
    'For add car to this order you should remove all car excluded employee are your sure ?',
  carCanNotBeEmpty: 'Car list can not be empty',
  thisEmployeeCantAddedCuzThisLoadHasCar:
    'This employee cant added because this Load has car',
  employeeShouldExist: 'At least one employee should exist',
  forAddExcludedCarToThisLoadYouShouldRemoveAllCarsAreYouSure:
    'For add excluded car employee you should remove all cars are you sure?',
  offer: 'Offer',
  chooseAtLeastOneTypeOfLoad: 'Choose at least one load type',
  driverInformation: 'Driver information',
  loadingStartTime: 'Loading start time',
  loadingEndTime: 'Loading end time',
  dischargeStartTime: 'Discharge start time',
  dischargeEndTime: 'Discharge end time',
  changeDriver: 'Change driver',
  driverEditedSuccessfully: 'Driver edited successfully',
  archiveDriver: 'Archive driver',
  deliveryState: 'Delivery state',
  orderCount: 'Order count',
  loading: 'loading',
  referToAdmin: 'Refer to admin',
  referToCourier: 'Refer to project',
  orderReferToCourierSuccessfully: 'Order refer to courier successfully',
  orderReferToAdminSuccessfully: 'Order refer to admin successfully',
  referTo: 'Refer to',
  typesShouldBeSame: 'Order type should be same',
  id: 'ID',
  courier: 'Courier',
  type: 'Type',
  creationTime: 'Creation Time',
  state: 'State',
  senderNationalId: 'Sender National ID',
  senderMobile: 'Sender Mobile',
  originProvince: 'Origin Province',
  originCity: 'Origin City',
  originAddress: 'Origin Address',
  originZipCode: 'Origin Zip Code',
  receiverNationalId: 'Receiver National ID',
  receiverMobile: 'Receiver Mobile',
  destinationProvince: 'Destination Province',
  destinationCity: 'Destination City',
  destinationAddress: 'Destination Address',
  destinationZipCode: 'Destination Zip Code',
  carType: 'Car Type',
  carLoad: 'Car Load',
  vehiclePlateNumber: 'Vehicle Plate Number',
  driverFullName: 'Driver Full Name',
  driverNationalId: 'Driver National ID',
  driverMobile: 'Driver Mobile',
  smartFleetNumber: 'Smart Fleet Number',
  productName: 'Product Name',
  productQuantity: 'Product Quantity',
  productWeight: 'Product Weight',
  productVolume: 'Product Volume',
  productPrice: 'Product Price',
  additionalServiceInsurance: 'Additional Service Insurance',
  additionalServicePackageTypeTitle: 'Package Type',
  additionalServiceTypeTitle: 'Additional Service Type',
  additionalServiceFactor: 'Additional Service Factor',
  additionalServiceCOD: 'COD',
  additionalServiceCapillaryDistribution: 'Capillary Distribution',
  additionalServiceWorker: 'Worker',
  additionalServiceDischargeLoad: 'Discharge Load',
  additionalService: 'Additional Service',
  factorId: 'Factor ID',
  totalCost: 'Total Cost',
  addedValue: 'Added Value',
  insurance: 'Insurance',
  driverCost: 'Driver Cost',
  trackingCode: 'Tracking Code',
  paymentType: 'Payment Type',
  senderFullName: 'Sender Full Name',
  receiverFullName: 'Receiver Full Name',
  excelReport: 'Excel report {title}',
  general: 'Order Details',
  sender: 'Origin Details',
  receiver: 'Destination Details',
  driver: 'Driver Details',
  product: 'Shipment Details',
  additionalService: 'Additional Services Request',
  pricing: 'Pricing',
  vehicleCarLoad: 'vehicle car load',
  orderDetail: 'Order Information',
  orderId: 'Order ID',
  orderId: 'Order ID',
  serviceType: 'Service Type',
  receiptRequired: 'Receipt Required',
  codService: 'COD Service',
  capillaryDistribution: 'Capillary Distribution',
  laborService: 'Labor Service',
  otherServices: 'Other Services',
  failedReason: 'Failed Reason',
  invoiceNumber: 'Invoice Number',
  valueAdded: 'Value Added',
  insuranceAmount: 'Insurance amount',
  additionalServices: 'Additional Services',
  driverFee: 'Driver Fee'
}
